export const MARKETPLACE_SECTIONS = {
  GENERAL: "general",
  PLANTS_GARDEN: "plants_garden",
};

export const PLANT_CATEGORY_OPTIONS = [
  { value: "vegetable_starts", label: "Vegetable Starts" },
  { value: "herbs", label: "Herbs" },
  { value: "fruit_plants", label: "Fruit Plants" },
  { value: "trees", label: "Trees" },
  { value: "shrubs", label: "Shrubs" },
  { value: "flowers", label: "Flowers" },
  { value: "perennials", label: "Perennials" },
  { value: "annuals", label: "Annuals" },
  { value: "houseplants", label: "Houseplants" },
  { value: "seeds", label: "Seeds" },
  { value: "bulbs", label: "Bulbs" },
  { value: "garden_supplies", label: "Garden Supplies" },
  { value: "other", label: "Other" },
];

export const PLANT_UNIT_OPTIONS = ["each", "tray", "pack", "pot", "bundle", "flat"];

export const PLANT_SUN_OPTIONS = [
  { value: "", label: "Not listed" },
  { value: "full_sun", label: "Full Sun" },
  { value: "partial_sun", label: "Partial Sun" },
  { value: "shade", label: "Shade" },
  { value: "varies", label: "Varies" },
];

export const PLANT_LIFE_CYCLE_OPTIONS = [
  { value: "", label: "Not listed" },
  { value: "annual", label: "Annual" },
  { value: "perennial", label: "Perennial" },
  { value: "biennial", label: "Biennial" },
  { value: "varies", label: "Varies" },
];

export const PLANT_INVENTORY_CATEGORY_MAP = {
  seed: "seeds",
  supplies: "garden_supplies",
  product: "vegetable_starts",
  other: "other",
};

export const getPlantCategoryLabel = (value) =>
  PLANT_CATEGORY_OPTIONS.find((option) => option.value === value)?.label || "Other";

export const getSunNeedsLabel = (value) =>
  PLANT_SUN_OPTIONS.find((option) => option.value === value)?.label || "";

export const getPlantLifeCycleLabel = (value) =>
  PLANT_LIFE_CYCLE_OPTIONS.find((option) => option.value === value)?.label || "";
